import PromotionTag from './PromotionTag';
import KoobTooltip from '../KoobTooltip';

const RequiredPromotionTag = ({ name, label }) => {
  return (
    <KoobTooltip tip={label} position="top" hasArrow={false} color="purple">
      <PromotionTag bgColor="#3AEDCC" name={name} />
    </KoobTooltip>
  );
};

export default RequiredPromotionTag;
